/* RESPONSIBLE TEAM: team-ml */
import Predicate from 'predicates/models/predicate';
import { computed } from '@ember/object';
export default Predicate.extend({
  isEditable: true,
  isLlmEvaluationType: true,
  genericType: 'llmEvaluation',
  defaultComparison: 'matches',
  // Override name to return the value directly (no attribute name for llm_evaluation)
  name: computed('value', function () {
    return this.value || '';
  }),
  // Override icon to return null since we don't have an attribute icon
  icon: computed(function () {
    return null;
  }),
  // Override description to return empty string since name already shows the value
  description: computed(function () {
    return '';
  }),
  getDefaultValue() {
    return '';
  }
});